<template>
  <template v-if="isDesktopScreen">
    <Modal :onCloseModal="handleModalClose" :title="overlayTitle" v-focus-trap="isFocusTrapEnabled" customClass="wishlist">
      <WishlistModalContent
        :handleModalClose="handleModalClose"
        :showToast="showToast"
        @wishlist-name-updated="onWishlistNameUpdated"
        :isDesktopScreen="isDesktopScreen"
      />
    </Modal>
  </template>

  <template v-else>
    <BottomDrawer :title="overlayTitle" v-focus-trap="isFocusTrapEnabled" :onCloseModal="handleModalClose">
      <WishlistModalContent
        :handleModalClose="handleModalClose"
        :showToast="showToast"
        @wishlist-name-updated="onWishlistNameUpdated"
        :isDesktopScreen="isDesktopScreen"
      />
    </BottomDrawer>
  </template>
</template>

<script setup>
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import Modal from '../../../global/modal.vue';
  import BottomDrawer from '../../../global/bottom-drawer.vue';
  import WishlistModalContent from './wishlist-modal-content.vue';

  const props = defineProps({
    showToast: {
      type: Function,
      default: () => {},
    },

    isDesktopScreen: {
      type: Boolean,
      default: true,
    },
  });

  const store = useStore();

  const isCreatingNewList = computed(() => store.state.showCreateNewListScreen);
  const productToWishlist = computed(() => store.state.productToWishlist);
  const renderOptions = computed(() => store.state.renderOptionsInWishlistModal);
  const overlayTitle = computed(() =>
    renderOptions.value
      ? productToWishlist.value.product.title
      : isCreatingNewList.value
      ? 'Create a New List'
      : 'Select Wishlist'
  );
  const isFocusTrapEnabled = computed(() => {
    return wishlistNameUpdated.value || isCreatingNewList.value || !wishlistNameUpdated.value || !isCreatingNewList.value;
  });

  const wishlistNameUpdated = ref(false); 

  const handleModalClose = () => {
    store.dispatch('showWishlistModal', false);
  };

  const onWishlistNameUpdated = (val) => {
    wishlistNameUpdated.value = val;
  };
</script>
